/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Modal } from '@nextui-org/react'
import React, { useEffect, useState } from 'react'

import { Empty } from 'antd'
import useGetApplications from '../../../hooks/useGetApplications'
import Chatbot from '../../Chatbot/Chatbot'
import Card from '../components/Card/Card'
import CardCandidate from '../components/CardCandidate/CardCandidate'
import ApplicationsWrapper from './Applications.style'

const Applications = () => {
  const { refetchApplications, data } = useGetApplications()
  const [visible, setVisible] = useState(false)
  const [offer, setOffer] = useState(null)
  const [actionType, setActionType] = useState(null)

  const modalContent = {
    offer: (
      <Modal.Body>
        <Card job={offer} fromApplicationTab />
      </Modal.Body>
    ),
    chatbot: (
      <Modal.Body>
        <Chatbot offer={offer} setVisible={setVisible} />
      </Modal.Body>
    ),
  }

  useEffect(() => {
    refetchApplications()
  }, [!visible, data])

  if (!data) {
    return null
  }

  const handleChatbotApply = (offer) => {
    setOffer(offer)
    setActionType('chatbot')
    setVisible(true)
  }

  const offersWithChatbot = data.offers
    .map((offer) => offer.offer)
    .map((offer) => ({
      offer,
    }))

  const applications = [...data.conversations, ...offersWithChatbot]

  const sortedApplications = applications.sort((a, b) => {
    if (a.createdAt === undefined) {
      return -1
    }
    if (b.createdAt === undefined) {
      return 1
    }
    return new Date(b.createdAt) - new Date(a.createdAt)
  })

  if (applications.length === 0) {
    return (
      <div
        style={{
          display: 'flex',
          marginTop: '15vh',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Empty description="Aucune candidature" />
      </div>
    )
  }

  // if Width < 768px => render Table else render Cards
  // if (window.innerWidth > 768) {
  //   return (
  //     <ApplicationsWrapper>
  //       <ApplicationTable
  //         applications={sortedApplications}
  //         handleChatbotApply={handleChatbotApply}
  //       />

  //       <Modal
  //         closeButton
  //         open={visible}
  //         onClose={() => setVisible(false)}
  //         blur
  //         scroll
  //         width="100%"
  //         fullScreen
  //       >
  //         {modalContent[actionType]}
  //       </Modal>
  //     </ApplicationsWrapper>
  //   )
  // }
  return (
    <>
      <ApplicationsWrapper>
        {sortedApplications.map((application) => (
          <CardCandidate
            app={application}
            key={application.offer.id}
            job={application.offer}
            handleChatbotApply={handleChatbotApply}
          />
        ))}

        <Modal
          closeButton
          open={visible}
          onClose={() => setVisible(false)}
          blur
          scroll
          width="100%"
          fullScreen
        >
          {modalContent[actionType]}
        </Modal>
      </ApplicationsWrapper>
    </>
  )
}

export default Applications
